import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit2-introduction',
  templateUrl: './unit2-introduction.component.html',
  styleUrls: ['./unit2-introduction.component.css']
})
export class Unit2IntroductionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
